import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-phone-in-green-circle',
  templateUrl: './svg-phone-in-green-circle.component.html',
})
export class SvgPhoneInGreenCircle {
  constructor() {}
}
